import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fkxglktbbrzonjifbaqs.supabase.co'
//const supabaseKey = process.env.SUPABASE_KEY
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZreGdsa3RiYnJ6b25qaWZiYXFzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0MjM0MTcsImV4cCI6MjA1Nzk5OTQxN30.0VaRQpH99SykojTf7_PQ6mtA5Idq3-Z8XVsvI1B1fkU"
const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase;